<template>
  <main class="eventosPainel">
    <header class="eventosCabecalho">
      <div>
        <p class="eventosEyebrow">Programação operacional</p>
        <h1>{{ viewMode == "eventos" ? "Eventos" : "Sources" }}</h1>
        <p class="eventosDescricao">
          {{
            viewMode == "eventos"
              ? "Gerencie a programação, as fontes e o estado das transmissões."
              : "Acompanhe as fontes disponíveis para transmissão."
          }}
        </p>
      </div>

      <div class="eventosCabecalhoResumo" v-if="viewMode == 'eventos'">
        <span>{{ totalEventos }}</span>
        <small>eventos carregados</small>
      </div>
    </header>

      <section class="eventosControles">
        <div class="eventosControlesTopo">
          <div class="eventosComandos">
            <button
              v-if="
                viewMode == 'eventos' &&
                retornaSite() !== 'Share' &&
                !pesquisaAtiva
              "
              type="button"
              class="eventosComando eventosComandoAbas"
              :class="{ eventosComandoAbasAtivo: tab }"
              @click="mostrarTab()"
            >
              <i class="fa fa-columns" aria-hidden="true"></i>
              Abas
            </button>

            <div class="eventosModo" role="group" aria-label="Visualizacao">
              <button
                type="button"
                :class="{ ativo: viewMode == 'eventos' }"
                @click="mostrarEventos()"
              >
                <i class="fa fa-calendar" aria-hidden="true"></i>
                Eventos
              </button>
              <button
                type="button"
                :class="{ ativo: viewMode == 'sources' }"
                @click="mostrarSources()"
              >
                <i class="fa fa-video-camera" aria-hidden="true"></i>
                Sources
              </button>
            </div>

            <button
              v-if="viewMode == 'eventos'"
              type="button"
              class="eventosComando eventosComandoPrincipal"
              data-toggle="modal"
              data-target="#dialogEdit"
              @click="itemNovo()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
              Novo evento
            </button>
            <button
              v-if="
                viewMode == 'eventos' &&
                retornaSite() !== 'Share' &&
                retornaSite() !== 'ShareApp'
              "
              type="button"
              class="eventosComando"
              @click="importarWilliamHill()"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
              Importar WH
            </button>
            <button
              v-if="viewMode == 'eventos' && retornaSite() == 'Weddbets'"
              type="button"
              class="eventosComando"
              title="Exportar eventos"
              @click="exportItens()"
            >
              <i class="fa fa-files-o" aria-hidden="true"></i>
              Exportar
            </button>
            <button
              v-if="viewMode == 'eventos' && retornaSite() == 'Weddbets'"
              type="button"
              class="eventosComando"
              title="Exportar resumo dos eventos"
              @click="exportItens(false)"
            >
              <i class="fa fa-list-alt" aria-hidden="true"></i>
              Resumo
            </button>
          </div>

          <button
            v-if="
              viewMode == 'eventos' &&
              itensSelecionados.length > 0 &&
              retornaSite() !== 'Share'
            "
            type="button"
            class="eventosSelecionados"
            data-toggle="modal"
            data-target="#dialogEditEventos"
            @click="clickSelecionados()"
          >
            {{ itensSelecionados.length }} selecionados
          </button>
        </div>

        <div
          v-if="retornaSite() !== 'ShareApp' && viewMode == 'eventos'"
          class="eventosFiltros"
        >
          <label class="eventosPesquisa">
            <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.868-3.834zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
              />
            </svg>
            <input
              v-model="filtroTexto"
              type="text"
              placeholder="Pesquisar eventos"
              autocomplete="off"
              @keyup="keyupFiltroTexto"
            />
          </label>

          <label
            v-if="retornaSite() !== 'Share'"
            class="eventosAgrupamento"
          >
            <span>Agrupar</span>
            <Combo
              :itens="agrupamentoEventosOpcoes"
              v-model="agrupamentoEventos"
            />
          </label>
        </div>

        <div
          v-if="viewMode == 'eventos' && visualizacaoAba"
          class="eventosAbas"
          role="tablist"
          aria-label="Situacao dos eventos"
        >
          <button
            type="button"
            :class="{ ativo: abaSelecionada == 'aovivo' }"
            @click="trocarAba('aovivo')"
          >
            Ao vivo ({{ itensAoVivo.length }})
          </button>
          <button
            type="button"
            :class="{ ativo: abaSelecionada == 'previsto' }"
            @click="trocarAba('previsto')"
          >
            Previsto ({{ itensPrevisto.length }})
          </button>
          <button
            type="button"
            :class="{ ativo: abaSelecionada == 'invisivel' }"
            @click="trocarAba('invisivel')"
          >
            Invisivel ({{ itensInvisivel.length }})
          </button>
          <button
            type="button"
            :class="{ ativo: abaSelecionada == 'finalizado' }"
            @click="trocarAba('finalizado')"
          >
            Finalizado ({{ itensFinalizado.length }})
          </button>
        </div>
      </section>

      <ListSources v-if="viewMode == 'sources'" />

      <h2
        class="tituloJogos"
        v-if="
          viewMode == 'eventos' &&
          retornaSite() !== 'Share' &&
          visualizacaoAba == false
        "
      >
        Ao vivo
      </h2>

      <p
        v-if="
          itensAoVivo.length == 0 &&
          viewMode == 'eventos' &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'aovivo')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        v-if="viewMode == 'eventos'"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'aovivo'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventosCompacto
          ref="refItensAoVivo"
          :itens="itensAoVivo"
          :tab="visualizacaoAba"
          :agrupamento="agrupamentoEventos"
          :transmissionStates="transmissionStates"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @encerrar="encerrar"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <h2
        class="tituloJogos"
        v-if="
          retornaSite() !== 'Share' &&
          viewMode == 'eventos' &&
          retornaSite() !== '7live' &&
          visualizacaoAba == false
        "
      >
        Previsto
      </h2>
      <h2
        class="tituloJogos"
        v-if="
          retornaSite() !== 'Share' &&
          viewMode == 'eventos' &&
          retornaSite() == '7live' &&
          visualizacaoAba == false
        "
      >
        Possíveis Jogos
      </h2>

      <p
        v-if="
          itensPrevisto.length == 0 &&
          viewMode == 'eventos' &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'previsto')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        v-if="viewMode == 'eventos' && retornaSite() !== 'Share'"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'previsto'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventosCompacto
          ref="refItensPrevisto"
          :itens="itensPrevisto"
          :tab="visualizacaoAba"
          :agrupamento="agrupamentoEventos"
          :transmissionStates="transmissionStates"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @aoVivo="aoVivo"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <h2
        class="tituloJogos"
        v-if="
          viewMode == 'eventos' &&
          retornaSite() !== 'Share' &&
          visualizacaoAba == false
        "
      >
        Invisivel
      </h2>

      <p
        v-if="
          itensInvisivel.length == 0 &&
          viewMode == 'eventos' &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'invisivel')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        v-if="viewMode == 'eventos' && retornaSite() !== 'Share'"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'invisivel'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventosCompacto
          ref="refItensInvisivel"
          :itens="itensInvisivel"
          :tab="visualizacaoAba"
          :agrupamento="agrupamentoEventos"
          :transmissionStates="transmissionStates"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <h2
        class="tituloJogos"
        v-if="
          viewMode == 'eventos' &&
          retornaSite() !== 'Share' &&
          visualizacaoAba == false
        "
      >
        Finalizado
      </h2>

      <p
        v-if="
          itensFinalizado.length == 0 &&
          viewMode == 'eventos' &&
          retornaSite() !== 'Share' &&
          (visualizacaoAba == false || abaSelecionada == 'finalizado')
        "
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div
        class="rowLista"
        v-if="viewMode == 'eventos' && retornaSite() !== 'Share'"
        :style="{
          display:
            visualizacaoAba == false || abaSelecionada == 'finalizado'
              ? 'block'
              : 'none',
        }"
      >
        <ListEventosCompacto
          ref="refItensFinalizado"
          :itens="itensFinalizado"
          :tab="visualizacaoAba"
          :agrupamento="agrupamentoEventos"
          :transmissionStates="transmissionStates"
          @selecionar="selecionar"
          @editarItem="editarItem"
          @transmitItem="transmitItem"
          @fonteItem="fonteItem"
          @excluirItem="excluirItem"
          @williamhillVincular="vincularWilliamHill"
        />
      </div>

      <EditEvento
        v-if="viewMode == 'eventos'"
        ref="editItem"
        @save-item="carregarItens(false)"
      />
      <EditEventos
        v-if="viewMode == 'eventos'"
        ref="editItemEventos"
        @limparSelecao="limparSelecao"
        :selecionados="itensSelecionados"
        @salvarItens="salvarItens"
        @excluirItens="excluirItens"
      />

      <WilliamHill
        v-if="viewMode == 'eventos'"
        ref="williamHill"
        @concluido="carregarItens(true)"
      ></WilliamHill>
  </main>
</template>

<script>
import { io } from "socket.io-client";
import { api } from "@/services/api.js";

import EditEvento from "../edits/EditEvento.vue";
import EditEventos from "../edits/EditEventos.vue";
import ListEventosCompacto from "../lists/ListEventosCompacto.vue";
import ListSources from "../lists/ListSources.vue";
import WilliamHill from "../pages/WilliamHill.vue";

import Combo from "../components/Combo.vue";

export default {
  name: "Eventos",
  components: {
    ListEventosCompacto,
    ListSources,
    EditEvento,
    EditEventos,
    Combo,
    WilliamHill,
  },
  props: {
    itensLimit: { type: Number, default: 500 },
    tab: { type: Boolean, default: false },
  },
  methods: {
    socketBaseUrl() {
      var apiUrl = process.env.VUE_APP_URL_API || "";

      if (apiUrl.endsWith("/api")) {
        apiUrl = apiUrl.substring(0, apiUrl.length - 4);
      }

      return apiUrl;
    },
    conectarSocketTransmissoes() {
      this.fecharSocketTransmissoes();

      const token = localStorage.getItem("ckd");

      if (!token) {
        return;
      }

      this.socketTransmissoes = io(this.socketBaseUrl(), {
        auth: {
          role: "manager",
          token,
          sourceKey: "event-list-monitor",
        },
        transports: ["websocket", "polling"],
      });

      this.socketTransmissoes.on("connect", () => {
        this.solicitarEstadoTransmissoes();
      });

      this.socketTransmissoes.on("source:transmit:state", (payload) => {
        this.aplicarEstadoTransmissoes(payload || {});
      });

      this.solicitarEstadoTransmissoes();
    },
    solicitarEstadoTransmissoes() {
      if (!this.socketTransmissoes) {
        return;
      }

      this.socketTransmissoes.emit("source:transmit:state:request", {
        eventoId: "",
      });
    },
    aplicarEstadoTransmissoes(payload) {
      const states = payload.transmissionStates || {};
      const next = {};

      Object.keys(states).forEach((key) => {
        const item = states[key] || {};

        if (
          item.active === true &&
          item.eventoId &&
          item.kind !== "preview"
        ) {
          next[item.eventoId.toString()] = item;
        }
      });

      this.transmissionStates = next;
    },
    fecharSocketTransmissoes() {
      if (this.socketTransmissoes) {
        this.socketTransmissoes.removeAllListeners();
        this.socketTransmissoes.disconnect();
      }

      this.socketTransmissoes = null;
    },
    retornaSite() {
      return this.$site;
    },
    selecionar(event, item) {
      var indexItem = this.itensSelecionados.indexOf(item._id);

      if (indexItem > -1) {
        this.itensSelecionados.splice(indexItem, 1);
      } else {
        this.itensSelecionados.push(item._id);
      }
    },
    clickSelecionados() {
      this.$refs.editItemEventos.limpar();
    },
    mostrarSources() {
      clearTimeout(this.timerRecarregar);
      this.limparSelecao();
      this.viewMode = "sources";
    },
    mostrarEventos() {
      this.viewMode = "eventos";
      this.carregarItens(this.retornaSite() !== "7live");
    },
    async carregarItens(auto) {
      if (this.viewMode !== "eventos") {
        return;
      }

      var obj = this;

      if (auto && this.itensSelecionados.length > 0) {
        clearTimeout(this.timerRecarregar);

        this.timerRecarregar = setTimeout(function () {
          obj.carregarItens(true);
        }, 20000);

        return;
      }

      //* Limpar selecao
      this.limparSelecao();

      var filtros = "";

      filtros += "?_limit=" + this.itensLimit + "&_page=1&editar=1";

      if (this.filtroTexto !== "") {
        filtros += "&_all=" + this.filtroTexto;
      }

      if (this.filtroSite !== "Todos") {
        filtros += "&site=" + this.filtroSite;
      }

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      var arrItensPrevisto = [];
      var arrItensInvisivel = [];
      var arrItensAoVivo = [];
      var arrItensFinalizado = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var item = response.data.itens[indiceEvento];

        var inserirItem = false;

        if (this.filtroSite !== "Todos") {
          if (this.filtroSite == item.site) {
            inserirItem = true;
          }
        } else {
          inserirItem = true;
        }

        if (inserirItem) {
          item.selecionado = false;

          if (item.situacao == 1) {
            arrItensPrevisto.push(item);
          }

          if (item.situacao == 2) {
            arrItensInvisivel.push(item);
          }

          if (item.situacao == 3) {
            arrItensAoVivo.push(item);
          }

          if (item.situacao == 4) {
            arrItensFinalizado.push(item);
          }
        }
      }

      this.itensPrevisto = arrItensPrevisto;
      this.itensInvisivel = arrItensInvisivel;
      this.itensAoVivo = arrItensAoVivo;
      this.itensFinalizado = arrItensFinalizado;

      if (auto) {
        clearTimeout(this.timerRecarregar);

        this.timerRecarregar = setTimeout(function () {
          obj.carregarItens(true);
        }, 20000);
      }
    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    transmitItem(id) {
      const path = this.retornaSite() == "7live" ? "/live/" : "/transmit-remote/";

      window.open(
        path + id,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=950,height=750",
        true
      );
    },
    fonteItem(link) {
      window.open(
        link,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    limparSelecao() {
      if (this.$refs.refItensPrevisto) {
        this.$refs.refItensPrevisto.limparSelecionados(false);
      }

      if (this.$refs.refItensInvisivel) {
        this.$refs.refItensInvisivel.limparSelecionados(false);
      }

      if (this.$refs.refItensAoVivo) {
        this.$refs.refItensAoVivo.limparSelecionados(false);
      }

      if (this.$refs.refItensFinalizado) {
        this.$refs.refItensFinalizado.limparSelecionados(false);
      }

      this.itensSelecionados = [];
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      var obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.carregarItens(false);
      }, 300);
    },
    async excluirItem(item) {
      var excluir = confirm("Deseja excluir o evento: " + item.nome);

      if (excluir == true) {
        await api.put("/evento/delete/" + item._id);
      }

      this.carregarItens(false);
    },
    salvarItens() {
      this.limparSelecao();
      this.carregarItens(false);
    },
    excluirItens() {
      this.limparSelecao();
      this.carregarItens(false);
    },
    async aoVivo(id) {
      var apiRequest;
      var body = {};

      if (confirm("Publicar como ao vivo ?")) {
        body.ids = [id];

        apiRequest = await api.put("/evento/aovivo", body);

        if (!apiRequest.data.erro) {
          this.carregarItens(false);
        }
      }
    },
    async encerrar(id) {
      var apiRequest;
      var body = {};

      if (confirm("Encerrar evento ?")) {
        body.ids = [id];

        apiRequest = await api.put("/evento/encerrar", body);

        if (!apiRequest.data.erro) {
          this.carregarItens(false);
        }
      }
    },
    async importarWilliamHill() {
      this.$refs.williamHill.abrir();
    },
    async vincularWilliamHill(_id) {
      this.$refs.williamHill.abrir("events", _id);
    },
    trocarAba(aba) {
      this.abaSelecionada = aba;
    },
    mostrarTab() {
      try {
        this.tab = !this.tab;
        localStorage.setItem("kjiConfigEventosTab", this.tab.toString());
      } catch (e) {
        console.log(e);
      }
    },
    exportItens(completo = true) {
      var conteudo = "";

      if (completo == true) {
        conteudo = "status\tdata\tnome\tpais\tcompeticao\tusuario\n";
      }

      var arrItensExport = [];

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "aovivo"
      ) {
        arrItensExport = arrItensExport.concat(this.itensAoVivo);
      }

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "previsto"
      ) {
        arrItensExport = arrItensExport.concat(this.itensPrevisto);
      }

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "invisivel"
      ) {
        arrItensExport = arrItensExport.concat(this.itensInvisivel);
      }

      if (
        this.visualizacaoAba.toString() == "false" ||
        this.abaSelecionada == "finalizado"
      ) {
        arrItensExport = arrItensExport.concat(this.itensFinalizado);
      }

      var ultimoTitulo = "";

      for (
        var indiceItem = 0;
        indiceItem < arrItensExport.length;
        indiceItem++
      ) {
        var item = arrItensExport[indiceItem];
        var itemStatus = "";

        //* Verifica situacao
        switch (item.situacao) {
          case 1:
            itemStatus = "Previsto";
            break;
          case 2:
            itemStatus = "Invisivel";
            break;
          case 3:
            itemStatus = "Ao Vivo";
            break;
          case 4:
            itemStatus = "Finalizado";
            break;
        }

        if (completo == true) {
          var itemData = "";

          try {
            itemData =
              item.dataDia.toString().padStart(2, "0") +
              "/" +
              item.dataMes.toString().padStart(2, "0") +
              "/" +
              item.dataAno +
              " " +
              item.dataHora.toString().padStart(2, "0") +
              ":" +
              item.dataMinuto.toString().padStart(2, "0");
          } catch (errData) {
            console.log(errData);
          }

          //this.formatDateTime(item.dataLancamento) +
          conteudo +=
            itemStatus +
            "\t" +
            itemData +
            "\t" +
            (item.nome ? item.nome : "") +
            "\t" +
            (item.pais ? item.pais : "") +
            "\t" +
            (item.competicao ? item.competicao : "") +
            "\t" +
            (item.usuarioCriacaoJoin && item.usuarioCriacaoJoin.length > 0
              ? item.usuarioCriacaoJoin[0].nome
              : "") +
            "\n";
        } else {
          if (ultimoTitulo !== itemStatus) {
            ultimoTitulo = itemStatus;
            conteudo += itemStatus + "\n";
          }

          conteudo +=
            item.dataHora.toString().padStart(2, "0") +
            ":" +
            item.dataMinuto.toString().padStart(2, "0") +
            " - " +
            (item.nome ? item.nome : "") +
            "\n";
        }
      }

      this.$copyText(conteudo).then(
        function (e) {
          alert("Copiado com sucesso!");
          console.log(e);
        },
        function (e) {
          alert("Impossivel copiar!");
          console.log(e);
        }
      );
    },
  },
  mounted() {
    try {
      var localConfigTab = localStorage.getItem("kjiConfigEventosTab");
      var localConfigAgrupamento = localStorage.getItem(
        "kjiConfigEventosAgrupamento"
      );

      if (this.retornaSite() !== "Share" && localConfigTab == "true") {
        this.tab = true;
      }

      if (
        this.agrupamentoEventosOpcoes.some(function (opcao) {
          return opcao.id === localConfigAgrupamento;
        })
      ) {
        this.agrupamentoEventos = localConfigAgrupamento;
      }
    } catch (e) {
      console.log(e);
    }

    this.carregarItens(this.retornaSite() !== "7live");
    this.conectarSocketTransmissoes();
  },
  beforeDestroy() {
    clearTimeout(this.timerFiltroTexto);
    clearTimeout(this.timerRecarregar);
    this.fecharSocketTransmissoes();
  },
  data: function () {
    return {
      filtroTexto: "",
      timerFiltroTexto: 0,
      timerRecarregar: 0,
      socketTransmissoes: null,
      transmissionStates: {},
      filtroSite: "Todos",
      itens: [],
      itensPrevisto: [],
      itensInvisivel: [],
      itensAoVivo: [],
      itensFinalizado: [],
      itensSelecionados: [],
      agrupamentoEventos: "sem",
      agrupamentoEventosOpcoes: [
        { id: "sem", nome: "-" },
        { id: "competicao", nome: "Competicao" },
        { id: "source", nome: "Source" },
        { id: "servidor", nome: "Servidor" },
      ],
      situacao: {
        1: "Previsto",
        2: "Invisivel",
        3: "Ao Vivo",
        4: "Finalizado",
      },
      editItem: null,
      abaSelecionada: "aovivo",
      viewMode: "eventos",
    };
  },
  computed: {
    totalEventos: function () {
      return (
        this.itensAoVivo.length +
        this.itensPrevisto.length +
        this.itensInvisivel.length +
        this.itensFinalizado.length
      );
    },
    visualizacaoAba: function () {
      if (this.filtroTexto.trim().length > 0) {
        return false;
      }

      return this.tab;
    },
    pesquisaAtiva: function () {
      return this.filtroTexto.trim().length > 0;
    },
  },
  watch: {
    agrupamentoEventos: function (valor) {
      const valorValido = this.agrupamentoEventosOpcoes.some(function (opcao) {
        return opcao.id === valor;
      });

      if (!valorValido) {
        return;
      }

      try {
        localStorage.setItem("kjiConfigEventosAgrupamento", valor);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style>
.eventosPainel {
  margin: 0 auto;
  max-width: 1320px;
  padding: 26px 16px 48px;
  text-align: left;
}

.eventosCabecalho {
  align-items: flex-end;
  border-bottom: 1px solid #dfe3e6;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 2px 15px;
}

.eventosEyebrow {
  color: #65717a;
  font-size: 10px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: uppercase;
}

.eventosCabecalho h1 {
  color: #242a2f;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.1;
  margin: 0;
}

.eventosDescricao {
  color: #6f7880;
  font-size: 11px;
  margin: 6px 0 0;
}

.eventosCabecalhoResumo {
  border-left: 3px solid #e3ad55;
  display: flex;
  flex-direction: column;
  min-width: 120px;
  padding: 2px 0 2px 12px;
}

.eventosCabecalhoResumo span {
  color: #30373d;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.eventosCabecalhoResumo small {
  color: #788188;
  font-size: 9px;
  margin-top: 4px;
}

.eventosControles {
  background: #f7f8f9;
  border-bottom: 1px solid #dfe3e6;
  border-top: 1px solid #dfe3e6;
  margin-bottom: 18px;
  padding: 12px 14px;
}

.eventosControlesTopo {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 30px;
}

.eventosComandos {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.eventosComando,
.eventosModo button,
.eventosSelecionados {
  border-radius: 3px;
  font-size: 10px;
  height: 28px;
  line-height: 1;
  padding: 0 9px;
  white-space: nowrap;
}

.eventosComando,
.eventosModo button {
  align-items: center;
  display: inline-flex;
  gap: 5px;
  justify-content: center;
}

.eventosComando svg,
.eventosModo button svg,
.eventosComando .fa,
.eventosModo button .fa {
  flex: 0 0 12px;
  font-size: 12px;
  height: 12px;
  text-align: center;
  width: 12px;
}

.eventosComando {
  background: #fff;
  border: 1px solid #adb5bd;
  color: #343a40;
}

.eventosComandoPrincipal {
  background: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}

.eventosComandoAtivo {
  background: #495057;
  border-color: #495057;
  color: #fff;
}

.eventosComandoAbas {
  background: #e8f4f1;
  border-color: #69a99a;
  color: #27685a;
}

.eventosComandoAbasAtivo {
  background: #d2ebe5;
  border-color: #3f8c79;
  color: #20594c;
  font-weight: 600;
}

.eventosModo {
  display: inline-flex;
}

.eventosModo button {
  background: #fff;
  border: 1px solid #adb5bd;
  color: #495057;
}

.eventosModo button:first-child {
  border-radius: 3px 0 0 3px;
}

.eventosModo button:last-child {
  border-left: 0;
  border-radius: 0 3px 3px 0;
}

.eventosModo button.ativo {
  background: #343a40;
  border-color: #343a40;
  color: #fff;
}

.eventosSelecionados {
  background: #fff;
  border: 1px solid #0d6efd;
  color: #0d6efd;
  margin-left: 10px;
}

.eventosFiltros {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.eventosPesquisa {
  align-items: center;
  border: 1px solid #ced4da;
  display: flex;
  flex: 1 1 320px;
  height: 34px;
  margin: 0;
  min-width: 220px;
  padding: 0 9px;
}

.eventosPesquisa:focus-within {
  border-color: #80bdff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.12);
}

.eventosPesquisa svg {
  color: #868e96;
  flex: 0 0 14px;
  height: 14px;
  margin-right: 7px;
  width: 14px;
}

.eventosPesquisa input {
  border: 0;
  color: #343a40;
  font-size: 12px;
  height: 30px;
  min-width: 0;
  outline: 0;
  padding: 0;
  width: 100%;
}

.eventosAgrupamento {
  align-items: center;
  border: 1px solid #ced4da;
  display: flex;
  flex: 0 0 240px;
  height: 34px;
  margin: 0;
}

.eventosAgrupamento > span {
  color: #6c757d;
  font-size: 10px;
  padding: 0 8px;
  white-space: nowrap;
}

.eventosAgrupamento .form-control {
  border: 0;
  border-left: 1px solid #e9ecef;
  border-radius: 0;
  box-shadow: none;
  color: #343a40;
  font-size: 11px;
  height: 32px;
  padding: 0 7px;
}

.eventosAbas {
  display: flex;
  gap: 0;
  margin-top: 9px;
}

.eventosAbas button {
  background: #fff;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #6c757d;
  font-size: 11px;
  height: 29px;
  min-width: 86px;
  padding: 0 10px;
}

.eventosAbas button.ativo {
  border-bottom-color: #0d6efd;
  color: #212529;
  font-weight: 600;
}

.eventosComando:hover,
.eventosModo button:hover,
.eventosSelecionados:hover,
.eventosAbas button:hover {
  filter: brightness(0.96);
}

.eventosComando:focus-visible,
.eventosModo button:focus-visible,
.eventosSelecionados:focus-visible,
.eventosPesquisa input:focus-visible,
.eventosAbas button:focus-visible {
  outline: 2px solid #80bdff;
  outline-offset: 1px;
}

.textoResumo {
  margin-bottom: 0px;
}

.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.botaoNovo {
  margin-top: 6px;
}

.eventosPainel .tituloJogos {
  border-bottom: 1px solid #e4e7e9;
  color: #343b41;
  font-size: 15px;
  font-weight: 600;
  margin: 24px 0 8px;
  padding-bottom: 7px;
  text-align: left;
}

@media (max-width: 767px) {
  .eventosPainel {
    padding: 18px 8px 36px;
  }

  .eventosCabecalho {
    align-items: flex-start;
  }

  .eventosCabecalho h1 {
    font-size: 22px;
  }

  .eventosDescricao {
    max-width: 250px;
  }

  .eventosCabecalhoResumo {
    min-width: 88px;
  }

  .eventosControles {
    padding-left: 9px;
    padding-right: 9px;
  }

  .eventosControlesTopo {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }

  .eventosSelecionados {
    margin-left: 0;
  }

  .eventosFiltros {
    align-items: stretch;
    flex-direction: column;
  }

  .eventosPesquisa,
  .eventosAgrupamento {
    flex-basis: auto;
    width: 100%;
  }

  .eventosAbas {
    overflow-x: auto;
  }

  .eventosAbas button {
    flex: 1 0 78px;
    min-width: 78px;
  }
}
</style>
